import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { formatMoney } from '../utils/utils.js';
require(`../assets/${process.env.PAGE}/css/components/CarAsPaymentQuote.css`);

class CarAsPaymentQuote extends Component {
  render() {
    const { carDetails } = this.props;
    const { car_price, car_model } = carDetails;
    const carAmount = car_price ? formatMoney(car_price, 0, ',', '.') : null;
    return (
      <div className="row text-center">
        <div className="car-offer-titles">
          <p className="car-offer-text">Vehículo:</p>
          {car_model && <h4>{car_model}</h4>}
        </div>
        <div className="car-offer-details text-center">
          <Row>
            <Col xs={12} md={12} lg={12} className="text-center">
              {carAmount ? (
                <div>
                  <p className="car-offer-text">Su valor estimado es:</p>
                  <p className="car-price">{carAmount}</p>
                  <span></span>
                </div>
              ) : (
                <p className="car-offer-text">
                  En este momento no podemos proporcionarte un valor estimado para tu auto usado. Sin embargo, podés continuar con tu simulación y nuestros expertos se encargarán de cotizar el valor de tu auto usado.
                </p>
              )}
            </Col>
          </Row>
        </div>
        <div className="car-offer-line" />
        <div className="car-offer-description">
          <p>
            El valor ofrecido del vehículo, es una estimación sujeto a detalles como kilometrajes y equipamiento.
          </p>
        </div>
        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form">Continuar Simulación</button>
        <div className="text-left">
          <button type="button" onClick={() => this.props.handleChildComponent('false')} className="btn btn-warning btn-lg pd-custom-button pd-form back">Volver</button>
        </div>
      </div>
    );
  }
}

export default CarAsPaymentQuote;


/** WEBPACK FOOTER **
 ** ./src/components/CarAsPaymentQuote.js
 **/